export const OFFERS_RESPONSIBLE_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OffersResponsibleUpdated";
export const OFFER_RESPONSIBLE_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferResponsibleInvalidated";
